"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("modal", {
    attrs: {
      show: true,
      "show-close": true
    },
    on: {
      close: _vm.close
    }
  }, [_c("h1", {
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_vm._v("Adicionar nova área")]), _vm._v(" "), _c("form", {
    attrs: {
      id: "formNewTypeService"
    }
  }, [_c("app-input", {
    attrs: {
      label: "Nome da aréa",
      placeholder: "Informe o nome",
      error: _vm.$v.form.Name.$error
    },
    on: {
      "update:error": function updateError($event) {
        return _vm.$set(_vm.$v.form.Name, "$error", $event);
      }
    },
    model: {
      value: _vm.$v.form.Name.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.Name, "$model", $$v);
      },
      expression: "$v.form.Name.$model"
    }
  }), _vm._v(" "), _c("app-input", {
    attrs: {
      expanded: "",
      label: "Client Token",
      placeholder: "Client Token",
      error: _vm.$v.form.SecretId.$error,
      type: "password"
    },
    on: {
      "update:error": function updateError($event) {
        return _vm.$set(_vm.$v.form.SecretId, "$error", $event);
      }
    },
    model: {
      value: _vm.$v.form.SecretId.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.SecretId, "$model", $$v);
      },
      expression: "$v.form.SecretId.$model"
    }
  }), _vm._v(" "), _c("app-input", {
    attrs: {
      expanded: "",
      label: "ID do cliente",
      placeholder: "ID do cliente",
      error: _vm.$v.form.ClientId.$error,
      type: "password"
    },
    on: {
      "update:error": function updateError($event) {
        return _vm.$set(_vm.$v.form.ClientId, "$error", $event);
      }
    },
    model: {
      value: _vm.$v.form.ClientId.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.ClientId, "$model", $$v);
      },
      expression: "$v.form.ClientId.$model"
    }
  }), _vm._v(" "), _c("app-input", {
    attrs: {
      expanded: "",
      label: "Webhook",
      placeholder: "Webhook do cliente",
      error: _vm.$v.form.UrlWebhook.$error,
      type: "password"
    },
    on: {
      "update:error": function updateError($event) {
        return _vm.$set(_vm.$v.form.UrlWebhook, "$error", $event);
      }
    },
    model: {
      value: _vm.$v.form.UrlWebhook.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.UrlWebhook, "$model", $$v);
      },
      expression: "$v.form.UrlWebhook.$model"
    }
  })], 1), _vm._v(" "), _c("b-button", {
    attrs: {
      slot: "footer",
      type: "is-info"
    },
    on: {
      click: _vm.checkForm
    },
    slot: "footer"
  }, [_vm._v("\n    Salvar\n  ")])], 1);
};
exports.render = render;
var staticRenderFns = [];
exports.staticRenderFns = staticRenderFns;
render._withStripped = true;